<!-- @Description 关于华院-荣誉资质 -->
<template>
  <div class="about-honour">
    <div class="about-honour-title">荣誉资质</div>
    <div class="about-honour-tabs">
      <div
        class="about-honour-tab"
        :class="{ active: activeTab === 'honor' }"
        @click="activeTab = 'honor'"
      >
        荣誉
        <!-- <span class="about-honour-tab-count">{{ honorList.length }}</span> -->
      </div>
      <div
        class="about-honour-tab"
        :class="{ active: activeTab === 'qualification' }"
        @click="activeTab = 'qualification'"
      >
        资质
        <!-- <span class="about-honour-tab-count">{{ qualificationList.length }}</span> -->
      </div>
    </div>

    <div v-show="activeTab === 'honor'" class="about-honour-grid">
      <div
        class="about-honour-item"
        v-for="(item, index) in honorList"
        :key="`honor-${index}`"
      >
        <div class="about-honour-item-text">{{ item }}</div>
      </div>
    </div>

    <div v-show="activeTab === 'qualification'" class="about-honour-qual-list">
      <div
        class="about-honour-qual-item"
        v-for="(item, index) in qualificationList"
        :key="`qual-${index}`"
      >
        <div class="about-honour-qual-badge">认证</div>
        <div class="about-honour-qual-text">{{ item }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "about-honour",
  data() {
    return {
      activeTab: "honor",
      honorList: [
        "工信部\n专精特新\n「小巨人」企业",
        "国家知识产权\n优势企业",
        "吴文俊人工智能\n科技进步 一等奖",
        "高等学校科学研究优秀成果奖（科学技术）\n一等奖",
        "高新技术企业",
        "上海市【专精特新】企业",
        "上海市专利工作\n试点企业",
        "上海软件和信息技术\n服务业高成长百家",
        "上海专精特新企业\n品牌价值100强",
        "福布斯中国人工智能\n科技企业TOP 50",
        "福布斯中国科创人物\n革新力人物",
        "福布斯中国人工智能\n影响力人物",
        "上海市人工智能创新中心\n（产业赋能）",
        "上海市「AI+制造」\n专业服务商",
        "上海市优质大数据\n服务供应商",
        "上海硬核科技企业\nTOP 100",
        "上海市生物医药产业\n数字化转型优秀应用场景",
        "中国数智化转型升级\n创新服务企业",
        "中国数智产业AI大模型\n先锋企业",
        "智能制造创新大赛\n制造业+AI赛道总决赛\n优秀奖",
        "全国企业新质生产力\n赋能典型案例",
        "AIGC领域最具\n商业合作价值企业",
        "中国AI智能体百强",
        "AI领航：中国人工智能\n产业实践先锋图景",
        "星空奖\n年度科技领航企业",
        "金猿奖|大数据产业\n年度创新技术突破",
        "中国开发者影响力\n年度榜单创新企业",
        "世界人工智能大会\n先锋引领奖",
        "数据智能应用典范金铃奖\n模型算法应用奖"
      ],
      qualificationList: [
        "CMMI5\n能力成熟度模型集成",
        "ISO20000\n信息技术服务管理体系",
        "ISO27001\n信息安全管理体系",
        "ISO9001\n质量管理体系",
        "ISO14001\n环境管理体系",
        "ISO45001\n职业健康安全管理体系",
        "知识产权合规\n管理体系",
        "信息技术服务标准\n（ITSS）",
        "信息系统建设和\n服务能力（CS）"
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.about-honour {
  padding: 44px 30px 96px;
  background: #ffffff;

  .about-honour-title {
    font-size: 40px;
    color: #08204d;
    line-height: 56px;
    text-align: center;
  }

  .about-honour-tabs {
    display: flex;
    margin: 32px auto 0;
    width: 480px;
    max-width: 100%;
    padding: 6px;
    background: #f0f4fa;
    border-radius: 48px;
  }

  .about-honour-tab {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 72px;
    font-size: 26px;
    color: #97a2b5;
    line-height: 36px;
    border-radius: 40px;
    cursor: pointer;
    transition: all 0.25s ease;

    &.active {
      font-weight: bold;
      color: #08204d;
      background: #ffffff;
      box-shadow: 0 4px 16px rgba(8, 32, 77, 0.08);
    }
  }

  .about-honour-tab-count {
    margin-left: 8px;
    font-size: 20px;
    font-weight: normal;
    color: #97a2b5;

    .active & {
      color: #5a6d8a;
    }
  }

  .about-honour-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 28px;
  }

  .about-honour-item {
    width: calc(50% - 6px);
    min-height: 152px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 12px;
    box-sizing: border-box;
    font-size: 20px;
    font-weight: bold;
    color: #08204d;
    line-height: 28px;
    background: url("../../../static/img/about/about_honour_crown.png")
      no-repeat 0 0 / 100% 100%;

    .about-honour-item-text {
      width: 82%;
      text-align: center;
      white-space: pre-line;
    }
  }

  .about-honour-qual-list {
    margin-top: 28px;
  }

  .about-honour-qual-item {
    display: flex;
    align-items: center;
    min-height: 96px;
    margin-bottom: 16px;
    padding: 20px 24px;
    background: linear-gradient(135deg, #f5f8fc 0%, #eef3fa 100%);
    border-radius: 12px;
    border-left: 6px solid #2952cc;
    box-sizing: border-box;
  }

  .about-honour-qual-badge {
    flex-shrink: 0;
    width: 72px;
    height: 72px;
    margin-right: 20px;
    font-size: 20px;
    font-weight: bold;
    color: #2952cc;
    line-height: 72px;
    text-align: center;
    background: #ffffff;
    border-radius: 50%;
    box-shadow: 0 2px 12px rgba(41, 82, 204, 0.12);
  }

  .about-honour-qual-text {
    flex: 1;
    font-size: 24px;
    font-weight: bold;
    color: #08204d;
    line-height: 36px;
    white-space: pre-line;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/about/honour.vue